<template>
  <Modal2 :modalId="modalId" ref="addModal">
    <div class="mdl-body-l">
      <h2>通知アドレスの追加</h2>

      <div class="primary-section">
        <div class="section-item row">
          <div class="col-md-5">
            <label class="col-form-label d-inline-block">
              通知メールアドレス<Icon type="required">必須</Icon>
            </label>
          </div>
          <div class="col-md-7">
            <Input
              placeholder="example@example.com"
              name="email"
              required
              :class="{
                'form-error': this.formErrors.notificationRecipient.getErrorMsg(
                  'email',
                ),
              }"
              v-model="formItems.notificationRecipient.email"
            />
            <div class="small notes notes-error">
              {{  this.formErrors.notificationRecipient.getErrorMsg('email') }}
            </div>
          </div>
        </div>

        <div class="row section-item">
          <div class="modal-footer btn-area">
            <Button variant="modal-dismiss" ref="dismissModal">
              キャンセル
            </Button>
            <Button @click="validate">登録する</Button>
          </div>
        </div>
      </div>

    </div>
  </Modal2>
</template>

<script>
/* 準標準ライブラリ */
import { mapGetters, mapActions } from "vuex";
/* 全画面共通 */
import { RepositoryFactory } from "repositories/factory";
import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";

/* コンポーネント */
import { Button, Icon, Input, Modal2 } from "components";
import { CrossIcon, SendIcon } from "icons";

/* モデル & バリデータ */
import NotificationRecipient from "models/notification-recipient";
import {
  NotificationRecipientsStoreValidator,
} from "validators/notification-recipients";

/* リポジトリモジュール  */
const NotificationRecipientsRepository = RepositoryFactory.get("notification-recipients");

export default {
  name: "NotificationRecipientCreateModal",
  props: {
    modalId: {
      type: String,
      default: "",
    },
  },
  components: {
    Modal2,
    Button,
    Icon,
    Input,
  },
  data() {
    return {
      icons: {
        CrossIcon,
        SendIcon,
      },
      formItems: {
        notificationRecipient: new NotificationRecipient(),
      },
      formErrors: {
        notificationRecipient: new NotificationRecipientsStoreValidator(),
      },
    };
  },
  computed: {
    ...mapGetters({
      /* ログイン情報 */
      userAccount: "profile/userAccount",
      currentServiceAccount: "service-account/currentServiceAccount",
      currentAsigProject: "asig-project/currentAsigProject",
      /* アプリステータス */
      isScreenActive: "application/isScreenActive",
    }),
  },
  methods: {
    ...mapActions({
      /* 画面ステータス更新 */
      updateScreenStatusCd: "application/updateScreenStatusCd",
      /* 通知制御 */
      resetNotification: "notification/resetState",
      setErrorNotification: "notification/setErrorNotification",
    }),
    async openModal() {
      this.formItems.notificationRecipient = new NotificationRecipient(
        this.currentServiceAccount.serviceAccountId,
      );
      this.formErrors.notificationRecipient = new NotificationRecipientsStoreValidator();
      this.$refs.addModal.openModal();
    },
    async validate() {
      try {
        this.updateScreenStatusCd(SCREEEN_STATUS_CD.PROCESSING);
        await this.resetNotification();

        // バリデーション
        this.formErrors.notificationRecipient = await NotificationRecipientsStoreValidator.validate(
          this.formItems.notificationRecipient.email,
          this.currentServiceAccount.serviceAccountId,
        );

        if (!this.formErrors.notificationRecipient.result) {
          this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
        } else {
          this.submit();
        }
      } catch (err) {
        console.log(err);
        // TODO: 発生したエラーを画面に反映
        this.setErrorNotification({
          message: "予期せぬエラーが発生しました。",
        });
        this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      }
    },
    async submit() {
      try {
        await NotificationRecipientsRepository.store(this.formItems.notificationRecipient);
        this.$emit("store");
      } catch (err) {
        console.log(err);
        // TODO: 発生したエラーを画面に反映
        this.setErrorNotification({
          message: "予期せぬエラーが発生しました。",
        });
      }
      this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      this.$refs.addModal.closeModal();
    },
  },
};
</script>
